const decodeJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(window.atob(base64));
  } catch (e) {
    return null;
  }
};

const ALL_PERMISSIONS = [
  "book:create",
  "book:read",
  "book:update",
  "book:delete",
];

const getToken = () => {
  try {
    return localStorage.getItem("token");
  } catch {
    return null;
  }
};

export const getUserPermissions = () => {
  const token = getToken();
  if (!token) return ALL_PERMISSIONS;

  const decoded = decodeJwt(token);
  return decoded?.permissions?.length ? decoded.permissions : ALL_PERMISSIONS;
};

export const hasPermission = (permission) =>
  getUserPermissions().includes(permission);
